export const AUTOMATION_IDS = {
  CHILD_BOX: 'section-child-box',
};
